/* eslint-disable @typescript-eslint/naming-convention */
import { ICreditCard } from '../../IDataMappings';
import { ICreditCardResponse } from '../../IApiResponses';

const savedCreditCardsMapper = {
  response(savedCreditCardsItems: ICreditCardResponse[]): ICreditCard[] {
    return (savedCreditCardsItems ?? []).map(item => {
      const {
        billing_address_id,
        card_type,
        default_payment_method,
        displaycardnum,
        expired,
        expires,
        cc_user_payment_method_id,
      } = item;
      return {
        billingAddressId: billing_address_id,
        displayCardNumber: displaycardnum,
        expires,
        isDefault: default_payment_method,
        isExpired: !!expired,
        type: card_type,
        userPaymentMethodId: cc_user_payment_method_id,
      };
    });
  },
};

export default savedCreditCardsMapper;